import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UserApiService } from 'src/app/services/api/user-api.service';

@Component({
  selector: 'app-change-commission-modal',
  templateUrl: './change-commission-modal.component.html',
  styleUrls: ['./change-commission-modal.component.scss'],
})
export class ChangeCommissionModalComponent {
  constructor(
    private modalRef: MatDialogRef<ChangeCommissionModalComponent>,
    private api: UserApiService
  ) {}

  close(r: any = null) {
    this.modalRef.close(r);
  }

  onOk() {
    this.close();
    this.closeChangeCommissionModal();
  }

  async closeChangeCommissionModal() {
    try {
      const r = await this.api.closeChangeCommissionModal();
    } catch (error) {}
  }
}
